import {
  Selector,
  PortalLayout,
  PopUpHeader,
  SelectedSvg,
} from 'react-gldn-kit';
import cln from 'classnames';

import styles from './PortalList.module.css';

type Props = {
  isOpen: boolean;
  callback: (b: {
    name: string;
    id: number;
  }) => (e: React.MouseEvent<HTMLDivElement>) => void;
  data: { name: string; id: number }[];
  activeId?: number;
  activeName?: string;
};

const PortalList = (props: Props) => {
  const { isOpen, callback, data, activeId, activeName } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <PortalLayout classes={styles.portalInx}>
      <div className={styles.list}>
        <PopUpHeader title="walletPopUp.forms.bank" />

        <div className={styles.portalContent}>
          {data.map((b) => (
            <div
              className={cln(styles.bankInfo, {
                [styles.active]: activeId === b.id || activeName === b.name,
              })}
              key={b.id}
              onClick={callback(b)}
            >
              <div>{b.name}</div>

              {(activeId === b.id || activeName === b.name) && <SelectedSvg />}
            </div>
          ))}
        </div>
      </div>
    </PortalLayout>
  );
};

export default PortalList;
